<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close (click)="onCancelClick()">Cancel</button>
  <span class="spacer"></span>
  <button mat-button [mat-dialog-close]="true" (click)="onDeleteClick()">Confirm</button>
</mat-dialog-actions>
